<template lang="html">
  <div id="sound-map-popup" @click="closeDialog">
    <div class="content">
      <div id="close-btn">x</div>
      <h2 class="title">{{dataObj.title}}</h2>
      <p v-if="dataObj.description !== ''">{{dataObj.description}}</p>
      <img v-if="dataObj.image_file" :src="imgSrc" :alt="`Csepel - ${dataObj.title}`">
      <div class="audio-wrapper">
        <audio controls="controls"
               controlsList="nodownload">
          <source :src="url" type="audio/mp3">
          Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'soundMapPopup',
  props: ['dataObj'],
  components: {},
  data: function () {
    return {
      url: `${this.$store.state.config.baseMediaURL}/${this.dataObj.sound_file}`,
      imgSrc: `${this.$store.state.config.baseMediaURL}/${this.dataObj.image_file}`,
    }
  },
  methods: {
    closeDialog (e) {
      if (e.target.id === 'sound-map-popup' || e.target.id === 'close-btn') this.$emit('close')
    }
  }
}
</script>

<style scoped>
  #sound-map-popup {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    background-color: rgba(40, 70, 120, 0.9);
    width: 100%;
    height: 100%;
  }
  #close-btn {
    position: absolute;
    top: 0;
    right: 0;
    color: var(--colorB);
    font-weight: bold;
    cursor: pointer;
    width: 25px;
    height: 25px;
    font-size: 1.3em;
  }
  .content {
    position: absolute;
    display: grid;
    grid-template-columns: minmax(min-content, max-content);
    grid-template-rows: minmax(min-content, max-content) minmax(min-content, max-content) minmax(min-content, max-content);
    align-items: start;
    justify-content: center;
    grid-gap: 10px;
    padding: 30px 15px;
    background-color: white;
    border-radius: 2px;
    width: 50%;
    right: 25%;
    top: 120px;
  }

  h2 {
    margin: 0 0 20px;
  }

  p {
    font-size: 16px;
    line-height: 1.6;
    letter-spacing: 0.02em;
    margin: 0 0 20px;
  }

  img {
    width: 100%;
    max-width: 480px;
    margin-bottom: 15px;
  }

  .audio-wrapper {
    display: flex;
    justify-content: center;
  }
</style>
